module.exports = __webpack_public_path__ + "img/ANTENNA RADIO PURPLE.6229617.svg";